import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root {
    --white: #ffffff;
    --black: #000000;

    --info-100: #caf0f8;
    --info-200: #90e0ef;
    --info-300: #48cae4;
    --info-500: #0077b6;

    --success-100: #b7efdc;
    --success-200: #4ad66d;
    --success-300: #2dc653;
    --success-500: #208b73;

    --warning-100: #fff2b2;
    --warning-200: #ffe169;
    --warning-300: #ffdd32;
    --warning-500: #c36f09;

    --danger-100: #f6cacc;
    --danger-200: #ec8385;
    --danger-300: #e66063;
    --danger-500: #d02224;

    --color-1: #4cc9f0;
    --color-2: #4895ef;
    --color-3: #2980b9;
    --color-4: #4361ee;
    --color-5: #3a0ca3;
    --color-6: #480ca8;
    --color-7: #560bad;
    --color-8: #7209b7;
    --color-9: #b5179e;

    --gray-100: #f8f9fa;
    --gray-200: #e9ecef;
    --gray-300: #dee2e6;
    --gray-400: #ced4da;
    --gray-500: #adb5bd;
    --gray-600: #6c757d;
    --gray-700: #495057;
    --gray-800: #343a40;
    --gray-900: #212529;
  }
  
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html { 
    @media(max-width: 1080px) {
      font-size: 93.75%; 
    }

    @media(max-width: 720px) {
      font-size: 87.5%; 
    }
  } 

  body {
    background: var(--gray-100);
    -webkit-font-smoothing: antialiased;
  }

  *, body, input, textarea, button {
    color: var(--gray-700);
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 600;
    color: var(--gray-800);
  }

  button, a {
    cursor: pointer;
  }

  [disabled] {
    opacity: 0.6; 
    cursor: not-allowed;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 3px;
  }

`;
